import { render, staticRenderFns } from "./BgsSdk.vue?vue&type=template&id=fbf88a70&scoped=true"
import script from "./BgsSdk.vue?vue&type=script&lang=js"
export * from "./BgsSdk.vue?vue&type=script&lang=js"
import style0 from "./BgsSdk.vue?vue&type=style&index=0&id=fbf88a70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf88a70",
  null
  
)

export default component.exports